import { NAME } from './constants';
import { router } from './router';

export const SplitBilling = {
	name: NAME,
	router,
};
